<template>
  <div
    class="wg-row com-anm22-app-scrolling-panel"
    style="justify-content:center;height:calc(100vh - 107px);padding:10px;"
  >
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker
          v-if="isFrom"
          :from="
            from == null || from == ''
              ? $moment().unix()
              : Number($moment(from).format('X'))
          "
          @customFunction="setFrom"
        ></world-date-picker>
        <world-date-picker
          v-else
          :from="
            to == null || to == ''
              ? $moment().unix()
              : Number($moment(to).format('X'))
          "
          @customFunction="setTo"
        ></world-date-picker>
      </div>
    </wg-modal>
    <div class="wg-row">
      <!-- Titolo e tasti di visualizzazione -->
      <div
        class="wg-row"
        style="align-items:center;justify-content:space-between;"
      >
        <div class="wg-col wg-xs-11">
          <slot></slot>
        </div>
        <!-- Switch visualizzazione -->
        <div
          class="wg-col wg-xs-1 display-flex"
          style="align-items:center;justify-content:flex-end;"
        >
          <img
            v-if="windowWidth <= 992"
            :src="$anm22.icons.getWorldIcon('chat')"
            class="com-anm22-app-img-s"
            style="cursor:pointer;margin-left:5px;"
            @click="$emit('openBoard')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height:25px;"></div>
      <div v-if="loading" class="wg-row" style="justify-content:center;">
        <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)" />
      </div>
      <template v-else>
        <template v-if="customComponents.length > 0 && !offline">
          <component
            v-for="(c, index) in customComponents"
            :key="'customComponent-' + index"
            :projectId="project.idWorldProject"
            :customerManager="customerManager"
            :is="c"
          ></component>
          <div class="vertical-height-div" style="height:15px;"></div>
        </template>
        <!-- Statistiche standard -->
        <template v-else>
          <!-- Date filter -->
          <WGFilters
            :filters="[
              {
                action: () => {
                  openPicker = !openPicker;
                  isFrom = true;
                },
                label: $anm22.strLang(lang, 'From', 'Da'),
                value: from,
                valueLabel: from ? from : '-',
              },
              {
                action: () => {
                  openPicker = !openPicker;
                  isFrom = false;
                },
                label: $anm22.strLang(lang, 'To', 'Al'),
                value: to,
                valueLabel: to ? to : '-',
              },
            ]"
            :language="lang"
          ></WGFilters>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div
            v-if="!(totalTaskHours || totalShiftHours || totalExpenses)"
            class="wg-row"
            style="justify-content:center;"
          >
            <div class="com-anm22-app-text-xxl">
              {{
                $anm22.strLang(
                  lang,
                  "Enter tasks, shifts or expenses to display the analytics",
                  "Inserire task, turni o spese per visualizzare le statistiche"
                )
              }}
            </div>
          </div>
          <template v-else>
            <div class="wg-row">
              <div class="com-anm22-app-text-xxl" style="font-weight:bold;">
                {{ $anm22.strLang(lang, "Totals", "Totali") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:20px;"></div>
            <div class="wg-row cake-row">
              <cake v-if="totalTaskHours" :obj="totalTaskHours" />
              <cake v-if="totalShiftHours" :obj="totalShiftHours" />
              <cake v-if="totalExpenses" :obj="totalExpenses" />
            </div>
            <div class="vertical-height-div" style="height:40px;"></div>
            <div v-if="checkUsers" class="wg-row">
              <div class="com-anm22-app-text-xxl" style="font-weight:bold;">
                {{ $anm22.strLang(lang, "Users", "Utenti") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:20px;"></div>
            <div
              v-for="(u, i) in users.filter(
                (u) =>
                  getUserTasksHours(u.idWorldUser) ||
                  getUserShiftsHours(u.idWorldUser) ||
                  getUserExpenses(u.idWorldUser)
              )"
              :key="'user-' + i"
              class="wg-row"
              style="margin-bottom:30px;"
            >
              <div
                class="wg-row"
                style="white-space:nowrap;align-items:center;"
              >
                <div style="min-width:22px;width:22px;height:22px;">
                  <world-object-icon
                    :type="'user'"
                    :obj="u"
                    :isImg="true"
                  ></world-object-icon>
                </div>
                <div style="margin-left:4px;" class="com-anm22-app-text-xl">
                  {{ u.name + " " + u.surname }}
                </div>
              </div>
              <div class="vertical-height-div" style="height:20px;"></div>
              <div class="wg-row cake-row">
                <cake
                  v-if="getUserTasksHours(u.idWorldUser)"
                  :obj="getUserTasksHours(u.idWorldUser)"
                  :scale="0.8"
                />
                <cake
                  v-if="getUserShiftsHours(u.idWorldUser)"
                  :obj="getUserShiftsHours(u.idWorldUser)"
                  :scale="0.8"
                />
                <cake
                  v-if="getUserExpenses(u.idWorldUser)"
                  :obj="getUserExpenses(u.idWorldUser)"
                  :scale="0.8"
                />
              </div>
            </div>
            <div class="vertical-height-div" style="height:40px;"></div>
            <div v-if="checkJobs" class="wg-row">
              <div class="com-anm22-app-text-xxl" style="font-weight:bold;">
                {{ $anm22.strLang(lang, "Jobs", "Postazioni") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:20px;"></div>
            <div
              v-for="(job, i) in jobs.filter((job) => getJobHours(job))"
              :key="'job-' + i"
              class="wg-row"
              style="margin-bottom:30px;"
            >
              <div
                class="wg-row"
                style="white-space:nowrap;align-items:center;"
              >
                <div class="job-icon">
                  {{
                    $anm22
                      .strLang(lang, job.en, job.it)
                      .substring(0, 1)
                      .toUpperCase()
                  }}
                </div>
                <div style="margin-left:4px;" class="com-anm22-app-text-xl">
                  {{ job[lang] }}
                </div>
              </div>
              <div class="vertical-height-div" style="height:20px;"></div>
              <div class="wg-row cake-row">
                <cake
                  v-if="getJobHours(job)"
                  :obj="getJobHours(job)"
                  :scale="0.8"
                />
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cake from "../components/statistics/Cake.vue";
import Spinner from "vue-simple-spinner";
import WorldDatePicker from "../../../../world/spa/components/WorldDatePicker.vue";
import WGFilters from "../../../../world/spa/components/WGFilters.vue";

export default {
  props: {
    boardOpen: Boolean,
    projectId: [Number, String],
    customerManager: [Boolean],
  },
  data() {
    return {
      loading: false,
      isFrom: false,
      openPicker: false,
      from: null,
      to: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      offline: (state) => state.offline.isOffline,
      windowWidth: (state) => state.windowWidth,
    }),
    checkUsers() {
      if (
        this.users.filter(
          (u) =>
            this.getUserTasksHours(u.idWorldUser) ||
            this.getUserShiftsHours(u.idWorldUser) ||
            this.getUserExpenses(u.idWorldUser)
        ).length > 0
      ) {
        return 1;
      }
      return 0;
    },
    checkJobs() {
      if (this.jobs.filter((job) => this.getJobHours(job)).length > 0) {
        return 1;
      }
      return 0;
    },
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    tasks() {
      return this.$store.getters["tasks/getByProject"](
        this.project.idWorldProject
      );
    },
    events() {
      return this.project.events
        .map((e) => this.$store.getters["events/get"](e))
        .filter((event) => event !== undefined);
    },
    outgoes() {
      return this.$store.getters["outgoes/getByProject"](this.projectId);
    },
    jobs() {
      let licenses = this.project.developers
        .map((w) => this.$store.getters["licenses/get"](w))
        .filter((l) => l);
      let jobs = licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
      return jobs;
    },
    users() {
      const users = [];
      // Recupero sia gli utenti attuali che quelli non più facenti parte dell'azienda
      this.project.users.forEach((u) => {
        if (!users.includes(u)) {
          users.push(u);
        }
      });
      this.tasks.forEach((t) => {
        t.users.forEach((u) => {
          if (!users.includes(u)) {
            users.push(u);
          }
        });
      });
      this.events.forEach((e) => {
        const invites = this.$store.getters["invites/getByEvent"](
          e.idWorldEvent
        ).filter((i) => i.status === 1);
        if (invites.length > 0) {
          invites.forEach((i) => {
            if (!users.includes(i.user)) {
              users.push(i.user);
            }
          });
        } else {
          if (!users.includes(e.creator)) {
            users.push(e.creator);
          }
        }
      });
      this.outgoes.forEach((o) => {
        if (!users.includes(o.user)) {
          users.push(o.user);
        }
      });
      return users
        .sort((a, b) => a - b)
        .map((u) => this.$store.getters["users/get"](u));
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter((e) => this.project.developers.includes(e.work))
        .map((e) => this.$store.getters["licenses/getByWork"](e.work))
        .filter((l) => l);
    },
    customComponents() {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.statistics &&
            l.config.tasks.statistics["add-to-dashboard"]
        )
        .map((l) => {
          const componentPath = l.config.tasks.statistics["add-to-dashboard"];
          return () => import("../components/custom/" + componentPath);
        });
    },
    //Statistiche
    totalTaskHours() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      //Recupero tutti i tasks di questo progetto
      const tasks = this.tasks.filter((t) => {
        // task not null
        let result = !!t;
        // date filters
        if (this.from) {
          result = result && !!t.actualEndDate && t.actualEndDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!t.actualEndDate && t.actualEndDate < toTs + 86399;
        }
        return result;
      });
      const actualHours = tasks.reduce(
        (hours, task) => hours + (task.actualWorkHours || 0),
        0
      );
      const expectedHours = tasks.reduce(
        (hours, task) => hours + (task.expectedWorkHours || 0),
        0
      );
      let color = "#ccc";
      if (expectedHours != 0) {
        const deviation = 100 - (actualHours / expectedHours) * 100;
        if (Math.abs(deviation) < 5) {
          if (deviation < 0) {
            //yellow
            color = "#ffeb3b";
          } else {
            //green
            color = "#01d479";
          }
        } else {
          if (deviation < 0) {
            color = "red";
          } else {
            //blue
            color = "#039be5";
          }
        }
      }
      return actualHours != 0 || expectedHours != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Tasks hours".toUpperCase() +
                "<br>" +
                "actual / Expected".toUpperCase(),
              "Ore task".toUpperCase() +
                "<br>" +
                "effettive / Previste".toUpperCase()
            ),
            val: this.hoursToText(actualHours),
            reference:
              expectedHours != 0 ? this.hoursToText(expectedHours) : null,
            color: color,
          }
        : null;
    },
    totalShiftHours() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      // Recupero tutti i tasks di questo progetto
      const shifts = this.events.filter((e) => {
        let result = !!e;
        // date filters
        if (this.from) {
          result = result && e.startTimestamp > fromTs;
        }
        if (this.to) {
          result = result && e.startTimestamp < toTs + 86399;
        }
        return result;
      });
      // Totale in secondi
      const total = shifts.reduce(
        (tot, s) =>
          tot + (s.endTimestamp - s.startTimestamp) * this.shiftUsers(s).length,
        0
      );
      // Previsione / dato non implementato al momento
      // if(expectedHours) {
      //   const deviation = 100 - (actualHours / expectedHours * 100);
      //   if(Math.abs(deviation) < 5) {
      //     color = 'green';
      //   } else {
      //     if(deviation < 0) {
      //       color = 'red';
      //     } else {
      //       color = 'blue';
      //     }
      //   }
      // }
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Shifts hours", "Ore turni")
              .toUpperCase(),
            val: this.hoursToText(total),
            color: "#ccc",
          }
        : null;
    },
    totalExpenses() {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const expenses = this.outgoes.filter((o) => {
        let result = !!o;
        // date filters
        if (this.from) {
          result = result && o.outgoDate > fromTs;
        }
        if (this.to) {
          result = result && o.outgoDate < toTs + 86399;
        }
        return result;
      });
      const total = expenses.reduce((tot, o) => tot + o.amount, 0);
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Expenses", "Spese")
              .toUpperCase(),
            val: total,
            unit: "EUR",
            color: "#ccc",
          }
        : null;
    },
  },
  methods: {
    shiftUsers(event) {
      const invites = this.$store.getters["invites/getByEvent"](
        event.idWorldEvent
      ).filter((i) => i.status === 1);
      if (invites.length > 0) {
        return invites.map((i) => this.$store.getters["users/get"](i.user));
      } else {
        return [this.$store.getters["users/get"](event.creator)];
      }
    },
    getUserTasksHours(userId) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      //Recupero tutti i tasks di questo progetto
      const tasks = this.tasks.filter((t) => {
        // task not null
        let result = !!t && t.users.includes(userId);
        // date filters
        if (this.from) {
          result = result && !!t.actualEndDate && t.actualEndDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!t.actualEndDate && t.actualEndDate < toTs + 86399;
        }
        return result;
      });
      const actualHours = tasks.reduce(
        (hours, task) =>
          hours + (task.actualWorkHours / task.users.length || 0),
        0
      );
      const expectedHours = tasks.reduce(
        (hours, task) =>
          hours + (task.expectedWorkHours / task.users.lenght || 0),
        0
      );
      let color = "#ccc";
      if (expectedHours != 0) {
        const deviation = 100 - (actualHours / expectedHours) * 100;
        if (Math.abs(deviation) < 5) {
          if (deviation < 0) {
            //yellow
            color = "#ffeb3b";
          } else {
            //green
            color = "#01d479";
          }
        } else {
          if (deviation < 0) {
            color = "red";
          } else {
            //blue
            color = "#039be5";
          }
        }
      }
      return actualHours != 0 || expectedHours != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Tasks hours".toUpperCase() +
                "<br>" +
                "actual / Expected".toUpperCase(),
              "Ore task".toUpperCase() +
                "<br>" +
                "effettive / Previste".toUpperCase()
            ),
            val: this.hoursToText(actualHours),
            reference: expectedHours != 0 ? this.hoursToText(expectedHours) : 0,
            color: color,
          }
        : null;
    },
    getUserExpenses(userId) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      const expenses = this.outgoes.filter((o) => {
        let result = !!o && o.user === userId;
        // date filters
        if (this.from) {
          result = result && o.outgoDate > fromTs;
        }
        if (this.to) {
          result = result && o.outgoDate < toTs + 86399;
        }
        return result;
      });
      const total = expenses.reduce((tot, o) => tot + o.amount, 0);
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Expenses", "Spese")
              .toUpperCase(),
            val: total,
            unit: "EUR",
            color: "#ccc",
          }
        : null;
    },
    getUserShiftsHours(userId) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      // Recupero tutti i tasks di questo progetto
      const shifts = this.events.filter((e) => {
        let result =
          !!e &&
          (e.creator === userId ||
            this.$store.getters["invites/getByEvent"](e.idWorldEvent).find(
              (i) => i.user === userId && i.status === 1
            ));
        // date filters
        if (this.from) {
          result = result && e.startTimestamp > fromTs;
        }
        if (this.to) {
          result = result && e.startTimestamp < toTs + 86399;
        }
        return result;
      });
      // Totale in secondi
      const total = shifts.reduce(
        (tot, s) => tot + (s.endTimestamp - s.startTimestamp),
        0
      );
      // Previsione / dato non implementato al momento
      let color = "#ccc";
      // if(expectedHours) {
      //   const deviation = 100 - (actualHours / expectedHours * 100);
      //   if(Math.abs(deviation) < 5) {
      //     color = 'green';
      //   } else {
      //     if(deviation < 0) {
      //       color = 'red';
      //     } else {
      //       color = 'blue';
      //     }
      //   }
      // }
      return total != 0
        ? {
            label: this.$anm22
              .strLang(this.lang, "Shifts hours", "Ore turni")
              .toUpperCase(),
            val: this.hoursToText(total),
            color: "#ccc",
          }
        : null;
    },
    getJobHours(job) {
      const fromTs = this.$moment.utc(this.from).unix();
      const toTs = this.$moment.utc(this.to).unix();
      //Recupero tutti i tasks che contengono il job in questione
      const tasks = this.tasks.filter((t) => {
        let result = !!t && t.jobs.includes(job.id);
        if (this.from) {
          result = result && !!t.actualEndDate && t.actualEndDate > fromTs;
        }
        if (this.to) {
          result =
            result && !!t.actualEndDate && t.actualEndDate < toTs + 86399;
        }
        return result;
      });
      const actualHours = tasks.reduce(
        (hours, task) => hours + (task.actualWorkHours || 0),
        0
      );
      const expectedHours = tasks.reduce(
        (hours, task) => hours + (task.expectedWorkHours || 0),
        0
      );
      let color = "#ccc";
      if (expectedHours != 0) {
        const deviation = 100 - (actualHours / expectedHours) * 100;
        if (Math.abs(deviation) < 5) {
          if (deviation < 0) {
            //yellow
            color = "#ffeb3b";
          } else {
            //green
            color = "#01d479";
          }
        } else {
          if (deviation < 0) {
            color = "red";
          } else {
            //blue
            color = "#039be5";
          }
        }
      }
      return actualHours != 0 || expectedHours != 0
        ? {
            label: this.$anm22.strLang(
              this.lang,
              "Tasks hours".toUpperCase() +
                "<br>" +
                "actual / Expected".toUpperCase(),
              "Ore task".toUpperCase() +
                "<br>" +
                "effettive / Previste".toUpperCase()
            ),
            val: this.hoursToText(actualHours),
            reference: expectedHours != 0 ? this.hoursToText(expectedHours) : 0,
            color: color,
          }
        : null;
    },
    hoursToText(value) {
      let string = "";
      const hours = Math.floor(value / 3600),
        minutes = Math.floor((value % 3600) / 60);
      string += `${hours}h`;
      if (minutes !== 0) {
        string += ` ${minutes}m`;
      }
      return string;
    },
    setFrom(newDate) {
      this.from = newDate;
      this.openPicker = false;
    },
    setTo(newDate) {
      this.to = newDate;
      this.openPicker = false;
    },
    loadData() {
      Promise.all(
        ["events", "invites", "outgoes", "tasks", "users"].map((d) => {
          return this.$store.dispatch(d + "/load", this.$vlf(d));
        })
      ).then((result) => {
        this.loading = false;
        this.$Progress.finish();
      });
    },
  },
  created() {
    this.loading = true;
    this.loadData();
    this.$http
      .get("project/analytics?idProject=" + this.projectId)
      .then((response) => {
        if (response.data) {
          Promise.all(
            ["events", "invites", "outgoes", "tasks", "users"].map((d) => {
              return this.$store.dispatch(d + "/update", {
                vlf: this.$vlf(d),
                objs: response.data[d],
                cleanFilters: [
                  (o) => o.project === this.project.idWorldProject,
                ],
              });
            })
          ).catch((error) => console.log(error));
        }
      })
      .catch((error) => console.log(error));
  },
  components: {
    Cake,
    WorldDatePicker,
    "vue-simple-spinner": Spinner,
    WGFilters,
  },
};
</script>

<style lang="scss" scoped>
.icon-picker {
  cursor: pointer;
  opacity: 0.7;
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  min-height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.job-icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #007fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  user-select: none;
  font-size: 14px;
}
@media only screen and (max-width: 349px) {
  .cake-row {
    justify-content: center;
  }
}
</style>
